const actions = {
    SALES_SETTLEMENT_DETAILS_START: 'SALES_SETTLEMENT_DETAILS_START',
    SALES_SETTLEMENT_DETAILS_SUCCESS: 'SALES_SETTLEMENT_DETAILS_SUCCESS',
    SALES_SETTLEMENT_DETAILS_FAILURE: 'SALES_SETTLEMENT_DETAILS_FAILURE',


    OPEN_INVOICE_DETAILS_START: 'OPEN_INVOICE_DETAILS_START',
    OPEN_INVOICE_DETAILS_SUCCESS: 'OPEN_INVOICE_DETAILS_SUCCESS',
    OPEN_INVOICE_DETAILS_FAILURE: 'OPEN_INVOICE_DETAILS_FAILURE',

    OPEN_PAYMENT_DETAILS_START: 'OPEN_PAYMENT_DETAILS_START',
    OPEN_PAYMENT_DETAILS_SUCCESS: 'OPEN_PAYMENT_DETAILS_SUCCESS',
    OPEN_PAYMENT_DETAILS_FAILURE: 'OPEN_PAYMENT_DETAILS_FAILURE',


    CLOSE_INVOICE_DETAILS_START: 'CLOSE_INVOICE_DETAILS_START',
    CLOSE_INVOICE_DETAILS_SUCCESS: 'CLOSE_INVOICE_DETAILS_SUCCESS',
    CLOSE_INVOICE_DETAILS_FAILURE: 'CLOSE_INVOICE_DETAILS_FAILURE',

    CLOSE_PAYMENT_DETAILS_START: 'CLOSE_PAYMENT_DETAILS_START',
    CLOSE_PAYMENT_DETAILS_SUCCESS: 'CLOSE_PAYMENT_DETAILS_SUCCESS',
    CLOSE_PAYMENT_DETAILS_FAILURE: 'CLOSE_PAYMENT_DETAILS_FAILURE',

    CLEAR_REPORT_DETAILS_START: 'CLEAR_REPORT_DETAILS_START',
    CLEAR_REPORT_DETAILS_SUCCESS: 'CLEAR_REPORT_DETAILS_SUCCESS'
};

export default actions;